import partial from "../../../lib/core/functional/partial";
import { indexOf } from "../../../lib/core/functional/curriedArray";
import thunk from "../../../lib/core/functional/thunk";

import freezePostRequest from "../../../transport/postFreeze";
import raiseNotification from "../../../utils/raiseNotification";
import { fetchSectionPostsOrdered } from "../../../transport/sectionPostsOrdered";

const isPossitive = (num) => {
    if (num < 0) {
        throw num;
    } else {
        return num;
    }
};

const onSuccess = thunk((context, element) => {
    raiseNotification(context.isFrozen ? "Post unfrozen" : "Post frozen", "success");
    context.isFrozen = !context.isFrozen;
    element.classList.toggle("active");
});

const onError = (error) => {
    console.error(error);
    raiseNotification(
        error.error || error.message || "There was an error freezing this post",
        "error"
    );
};

export default function freeze(context, element) {
    return fetchSectionPostsOrdered(context.sectionId)
        .then(indexOf(parseInt(context.postId, 10)))
        .then(isPossitive)
        .then(partial(freezePostRequest, context.postId, context.isFrozen, context.sectionId))
        .then(onSuccess(context, element))
        .catch(onError);
}
